import React, { useState } from 'react';

const ListarGestionAdministrativaPage = () => {
    // Estado para la fecha dinámica
    const [fecha, setFecha] = useState('');

    // Estados para la respuesta y errores
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [respuesta, setRespuesta] = useState(null);

    // Función para enviar los datos a la API usando GET
    const enviarDatos = async () => {
        setLoading(true);
        setError(null);
        setRespuesta(null);

        // Crear el JSON completo
        const datos = {
            Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
            Ambiente: 'DESA',
            Dispositivo: {
                Marca: 'SAMSUNG',
                Modelo: 'S22002B',
                Version: 'Android 18.125',
                McAdress: null,
                PowerStatus: '84%',
                WifiStatus: 'Conected to iphone de Mauricio',
                GPSStatus: 'ON',
                GPS: '321|-485|321',
            },
            Usr: {
                Codigo: '',
                UserNickName: 'pierril',
            },
            DatosMetodo: {
                NombreMetodo: 'ListarGestionAdministrativa',
                Datos_Recibidos: JSON.stringify({ Fecha: fecha }), // Fecha dinámica
            },
        };

        // Construir la URL con los datos codificados
        const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
            JSON.stringify(datos)
        )}`;

        try {
            // Enviar la solicitud a la API usando GET
            const response = await fetch(fetchDataUrl);
            const data = await response.json();
            console.log('Respuesta de la API:', data);

            // Convertir datos_Generados de string a JSON
            if (data.datos_Generados) {
                const datosGenerados = JSON.parse(data.datos_Generados); // Convertir a JSON
                console.log('Datos Generados (JSON):', datosGenerados);

                // Convertir GESTION_ADMINISTRATIVA a JSON si es un string
                if (typeof datosGenerados.GESTION_ADMINISTRATIVA === 'string') {
                    datosGenerados.GESTION_ADMINISTRATIVA = JSON.parse(datosGenerados.GESTION_ADMINISTRATIVA);
                }

                // Guardar la respuesta procesada
                setRespuesta(datosGenerados.GESTION_ADMINISTRATIVA);
            } else {
                setError('No se encontraron datos generados en la respuesta.');
            }
        } catch (error) {
            console.error('Error al procesar la respuesta:', error);
            setError('Error al procesar la respuesta de la API.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
            <h1>Listar Gestión Administrativa</h1>

            {/* Formulario para ingresar la fecha dinámica */}
            <div style={{ marginBottom: '20px' }}>
                <h2>Ingresar Fecha</h2>
                <input
                    type="date"
                    value={fecha}
                    onChange={(e) => setFecha(e.target.value)}
                    style={{ padding: '5px', fontSize: '16px' }}
                />
            </div>

            {/* Botón para enviar datos */}
            <button onClick={enviarDatos} disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar Datos'}
            </button>

            {/* Mostrar errores */}
            {error && (
                <div style={{ marginTop: '20px', color: 'red' }}>
                    <h2>Error:</h2>
                    <p>{error}</p>
                </div>
            )}

            {/* Mostrar la tabla con los datos */}
            {respuesta && (
                <div style={{ marginTop: '20px' }}>
                    <h2>Datos de Gestión Administrativa</h2>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f2f2f2' }}>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Código</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Factura</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Fecha</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Caja</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Sucursal</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Vendedor</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Tipo Servicio</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>NIT</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Cliente</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Dirección</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Comentario</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Teléfono</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Área</th>
                                <th style={{ padding: '10px', border: '1px solid #ddd' }}>Medio Pago</th>
                            </tr>
                        </thead>
                        <tbody>
                            {respuesta.map((gestion, index) => (
                                <tr key={index} style={{ border: '1px solid #ddd' }}>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_codigo}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_factura}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_fecha}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_caja}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_sucursal}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_vendedor}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_tipo_servicio}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_nit}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_cliente_nombre}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_DIRECCION_ENVIO}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_COMENTARIO_ENVIO}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_TELEFONO}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_AREA_ZONA}</td>
                                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>{gestion.dom_medio_pago}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default ListarGestionAdministrativaPage;